/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrophy} from '@fortawesome/pro-duotone-svg-icons';

const GoalIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faTrophy} {...props} />
);

export default GoalIcon;
